module.exports = __webpack_public_path__ + "static/img/Desi Siti Maryam-full.68af388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Desi Siti Maryam-full.png
// module id = q55Y
// module chunks = 1